<template>
  <div class="weekly-list-work-item">
    <div class="header">
      <div class="top">
        <span>{{ item.username }}</span>同学
      </div>
      <div class="bottom">阅读《{{ item.book }}》的作品</div>
    </div>
    <div class="body">
      <ym-img v-for="(item,index) in item.work.imgs"
              :key="index"
              class="image"
              :src="item"
      />
      <div v-if="item.work.text"
           class="content">
        {{ item.work.text }}
      </div>
      <div class="teacher">
        <ym-img class="teacher-header"
                :src="require('@/assets/img/million_read/weekly/teacher_header.png')"
        />
        <div class="teacher-body">
          {{ item.teacherWords }}
        </div>
      </div>
    </div>
    <ym-img class="footer"
            :src="require('@/assets/img/million_read/weekly/work_footer.png')"
    />
  </div>
</template>

<script>
  export default {
    name: 'MillionReadWeeklyReportWorkItem',
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
    methods: {},
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .weekly-list-work-item {
    position: relative;
    z-index: 2;
    margin-bottom: 110px;
    .header,
    .footer {
      display: block;
      width: 100%;
    }
    .header {
      height: 206px;
      background-image: url('~@/assets/img/million_read/weekly/work_header.png');
      background-size: 100%;
      box-sizing: border-box;
      color: @color-white;
      font-size: @font-size-small;
      padding-left: 170px;
      padding-top: 70px;
      display: flex;
      flex-direction: column;
      .top {
        span {
          font-size: @font-size-large;
          text-decoration: underline;
          padding-right: 5px;
        }
      }
    }
    .body {
      min-height: 100px;
      background-image: url('~@/assets/img/million_read/weekly/work_body.png');
      background-size: 100%;
      background-repeat: repeat-y;
      .image {
        display: block;
        width: 550px;
        padding-left: 100px;
        margin-bottom: 30px;
      }
      .content {
        color: #333;
        font-size: @font-size-small;
        line-height: @font-size-extra-large;
        padding: 40px 100px 0;
      }
      .teacher {
        margin-top: 60px;
        margin-left: 76px;
        &-header {
          width: 610px;
          height: 75px;
          display: block;
        }
        &-body {
          background-image: url('~@/assets/img/million_read/weekly/teacher_body.png');
          background-size: 100%;
          background-repeat: repeat-y;
          width: 610px;
          color: #333;
          font-size: @font-size-extra-extra-small;
          line-height: @font-size-large;
          text-decoration: underline;
          padding: 0 25px 25px 55px;
          box-sizing: border-box;
        }
      }
    }
    .footer {
      height: 70px;
      margin-top: -1px;
    }
  }
</style>
